/**
 * Created by danielr on 08-Jun-15.
 *
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var ManagerConfig = require("manager-assets/config/managerConfig.json");
    var template = require("manager-templates/data-sources/integrations/authentication/authenticationServerView.tmpl");
    var Button = require("ui/button/Button");
    var Dropdown = require("ui/dropdown/Dropdown");
    var KpContent = require("ui.components/kpContent/kpContent");
    var AuthenticationTypeViewBuilder = require("manager-views/data-sources/integrations/authentication/AuthenticationTypeViewBuilder");
    var AuthenticationServerModel = require("manager-models/data-sources/integrations/authentication/AuthenticationServerModel");

    var AUTH_TYPE_MAPPING = {};
    AUTH_TYPE_MAPPING["" + AuthenticationServerModel.TYPES.OAUTH2_IMPLICIT] = "oauth2Implicit";
    AUTH_TYPE_MAPPING["" + AuthenticationServerModel.TYPES.OAUTH2_CODE] = "oauth2Code";
    AUTH_TYPE_MAPPING["" + AuthenticationServerModel.TYPES.LP_AUTH] = "LPAuth";

    var AuthenticationServerView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        AuthenticationServerView = Marionette.Layout.extend({
            template : template,
            className : "auth-server-container",
            withUIComponents : true,

            ui : {
                KPSetupContainer: ".kp-setup-container",
                AuthTypeSelector: ".auth-type-selector",
                AuthTypeContainer: ".auth-type-container",
                KPChooseContainer: ".kp-choose-container",
                cancelButton:     ".button-cancel",
                saveButton:       ".button-save"
            },
            regions: {
                authTypeRegion: ".auth-type-container"
            },
            uiComponents : {
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_onCancel"
                    }
                },
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        /*initState:"view._getSaveButtonState",*/
                        tooltip:  "view._getSaveButtonTooltip",
                        tooltipAlign: Button.TOOLTIP_ALIGN.RIGHT
                    },
                    events: {
                        "click": "_onSave"
                    }
                },
                authTypeSelector: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.AuthTypeSelector",
                        name : "authTypeSelector",
                        selectedOption: "view._getSelectedAuthType",
                        items : "view._getAuthTypeList",
                        permutation: Dropdown.PERMUTATION.MEDIUM,
                        placeholder: LE.translator.translate("LEManager.manager.dataSources.authentication.server.select.authType.caption")
                    },
                    events: {
                        "change": "_onAuthTypeChange"
                    }
                },
                kpSetupButton: {
                    type: KpContent,
                    options: {
                        container: "view.ui.KPSetupContainer",
                        KPLink: LE.translator.translate("LEManager.manager.dataSources.authentication.server.kp.setup"),
                        kpID: "setup-authchat",
                        showKPIcon: true
                    }
                },

                kpChooseButton: {
                    type: KpContent,
                    options: {
                        container: "view.ui.KPChooseContainer",
                        KPLink: LE.translator.translate("LEManager.manager.dataSources.authentication.server.kp.choose"),
                        kpID: "how-to-mark",
                        showKPIcon: true
                    }
                }
            },
            modelEvents: {
                "change": "_toggleSaveBtn",
                "change:authType": "_renderAuthenticationTypeView" //TODO: why this si never called?
            },

            initialize : function (options) {
                LEManager.logger.debug("AuthenticationServerView:initialize");
                this.channel = LEManager.media.channel("dataSources");
                this.listenTo(this, "page:closeButtonClick", this._onCancel);
            },

            onRender: function(){
                this.currentAuthTypeId = this.uiComponents.authTypeSelector.getValue();
                this._renderAuthenticationTypeView(); //TODO: should not be called. the model event should trigger it
                this._toggleSaveBtn();
            },

            _onAuthTypeChange: function(componentId, eventName, value){
                LEManager.logger.debug("AuthenticationServerView:_onAuthTypeChange");
                this._toggleSaveBtn();
                if (_.isObject(value) && _.has(value, "selectedKey")){
                    LEManager.logger.debug("AuthenticationServerView:_onAuthTypeChange - selectedKey: " + value.selectedKey);
                    this.model.setAuthType(value.selectedKey);
                    var data = {
                        selectedAuthTypeId: value.selectedKey,
                        previousState: {
                            authTypeId: this.currentAuthTypeId,
                            authTypeModel: this.model.getAuthTypeModel()
                        }
                    };
                    this.currentAuthTypeId = value.selectedKey;
                    this.channel.trigger(ManagerConfig.dataSources.mainConfig.authenticationServer.TRIGGERING.AUTH_TYPE_CHANGE, data);
                }
            },

            _renderAuthenticationTypeView: function(){
                LEManager.logger.debug("AuthenticationServerView:_renderAuthenticationTypeView");
                var authType = this.model.getAuthType();
                LEManager.logger.debug("AuthenticationServerView:_renderAuthenticationTypeView - authType: " + authType);
                if (!_.isNull(authType)) {
                    this.authView = AuthenticationTypeViewBuilder.createViewByType(authType, {model: this.model.getAuthTypeModel()});
                    this.authTypeRegion.show(this.authView);
                }
            },

            _getSaveButtonState : function () {
                LEManager.logger.debug("AuthenticationServerView:_getSaveButtonState");
                return !_.isUndefined(this.uiComponents.authTypeSelector) && this.model.isDefinedAuthTypeId() ? Button.STATES.ENABLED : Button.STATES.DISABLED;
            },

            _toggleSaveBtn: function () {
                var newState = this._getSaveButtonState();
                this.uiComponents.saveButton.setState(newState);
            },

            _getSelectedAuthType: function(){
                LEManager.logger.debug("AuthenticationServerView:_getSelectedAuthType");
                var selectedType = this.model.getAuthType();
                if (selectedType === AuthenticationServerModel.TYPES.LP_AUTH && !LE.sessionManager.hasLpAuthenticationSupportFeature()) {
                    selectedType = null;
                }
                return selectedType;
            },

            _getAuthTypeList: function(){
                LEManager.logger.debug("AuthenticationServerView:_getAuthTypeList");
                var authTypeList = AuthenticationServerModel.TYPES_LIST;
                if(!LE.sessionManager.hasLpAuthenticationSupportFeature()){
                    authTypeList = _.without(authTypeList, AuthenticationServerModel.TYPES.LP_AUTH);
                }
                var items = _.union(items, _.map(authTypeList, function(typeId) {
                    var elementKey = AUTH_TYPE_MAPPING[typeId.toString()];
                    return {
                        key:   typeId,
                        value: LE.translator.translate('LEManager.manager.dataSources.authentication.server.authType.' + elementKey),
                        tooltipPosition: Dropdown.TOOLTIP_POSITION.RIGHT
                    };
                }));
                return new Dropdown.Collection(items);
            },

            _onSave: function(){
                LEManager.logger.debug("AuthenticationServerView:_onSave");
                var isValid = this.model.isValidAttr();
                if (isValid){
                    LEManager.logger.debug("AuthenticationServerView:_onSave - form is valid");
                    this.channel.trigger(ManagerConfig.dataSources.mainConfig.authenticationServer.TRIGGERING.SAVE, this.model);
                }
            },

            _onCancel : function () {
                LEManager.logger.debug("AuthenticationServerView:_onCancel");
                this.channel.trigger(ManagerConfig.dataSources.mainConfig.authenticationServer.TRIGGERING.CLOSE);
            },

            onClose : function () {
                LEManager.logger.debug("AuthenticationServerView:onClose");
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    return AuthenticationServerView;
});
